export default function (next, store) {
  if (!store.state.isLoggedIn) {
    localStorage.setItem("intendedRoute", window.location.pathname);
    next("/login");
  } else {
    next();
  }
}
